/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'm18.7 9-1.4-1.4-4.6 4.6a1 1 0 0 1-1.4 0L6.7 7.6 5.2 9l6.8 6.7L18.7 9Z',
  DEV ? 'ChevronDownIcon' : '',
  '',
  false,
);
